import APIServiceLookUp from './serviceAPI';
import { API_URL } from './models/AppConstent';

export default class ServiceDonation {
    lookupService = new APIServiceLookUp();

    async getAllDonation(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}donation/getAllDonation`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async updateDonation(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}donation/updateDonation`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async delDonation(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}donation/delDonation`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }
}